import { request } from '../request'

// 获取任务分组列表
export const getTaskGroups = params => request('/portal/common/task/groups', { params: params })

// 获取agent列表
export const getAgentList = (params?: { os?: string[]; arch?: string[] }) =>
  request('/portal/v1/task/agent_list', { params })

// 获取主机列表
export const getHostList = () => request('/portal/v1/task/host_list')

// 根据hostId获取设备列表
export const getDeviceListByHostId = (id?: string) =>
  request(`/portal/v1/es/host/${id}/device`, { params: { scene: 'SCENEID_CONTAINTERSECURE' } })

// 获取人员邮箱列表
export const getEmailList = () => request('/portal/common/email_users')

// 创建任务
export const createTask = data =>
  request('/portal/verify/containerSecurity/createTask', {
    method: 'post',
    data,
  })

// 获取模板列表
export const getTemplateList = data =>
  request('/portal/common/resourceTemplates', {
    method: 'post',
    data,
  })

// 获取模板id列表
export const getTemplateIdList = data =>
  request('/portal/common/resourceTemplates/ids', {
    method: 'post',
    data,
  })

// 获取攻击类型列表
export const getAttackTypeList = (data: { resourceIds: string[] }) =>
  request('/portal/common/attack/attack_type_filter_list', {
    method: 'get',
    params: data,
  })

// 获取用例列表
export const getCaseList = data =>
  request('/portal/common/resourceTemplate/resources', {
    method: 'post',
    data,
  })

// 获取用例id列表
export const getCaseIdList = data =>
  request('/portal/common/resourceTemplate/filter/ResourceIds', {
    method: 'post',
    data,
  })

// 获取用例标签列表
export const getCaseTagList = (data: { resourceIds: string[] }) =>
  request('/portal/common/resources/tag/list', {
    method: 'post',
    data,
  })

// 获取全局参数配置
export const getGlobalParam = () => request('/portal/verify/containerSecurity/getGlobalParam')

// 修改全局参数配置
export const updateGlobalParam = (data: any) =>
  request('/portal/verify/containerSecurity/updateGlobalParam', {
    method: 'put',
    data,
  })

// 添加用例模板
export const addCaseTemplate = (data: { name: string; resourceIds: string[] }) =>
  request('/portal/common/resourceTemplate', { method: 'post', data })

// 样本文件下载
export const getSampleFile = (data: { resourceId: string; sha256: string }) =>
  request(`/portal/verify/containerSecurity/plugin/${data.resourceId}/sample/${data.sha256}`, {
    method: 'get',
    headers: {
      'Content-Type': 'application/octet-stream',
      Accept: 'application/octet-stream',
    },
    responseType: 'blob',
  })

// 获取用例详情
export const getPluginDetail = (data: { resourceId: string }) =>
  request('/portal/verify/containerSecurity/pluginDetail', {
    method: 'get',
    params: data,
  })

// 修改用例详情
export const updatePluginDetail = (data: { plugin_id: string; param: any[] }) =>
  request('/portal/verify/containerSecurity/updatePluginDetail', { method: 'put', data })
